import { DomSanitizer } from '@angular/platform-browser';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



@Component({
  selector: 'app-autorisation-camera',
  templateUrl: './autorisation-camera.component.html',
  styleUrls: ['./autorisation-camera.component.scss']
})
export class AutorisationCameraComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public element: any, public sanitizer: DomSanitizer, public dialogRef: MatDialogRef<AutorisationCameraComponent>) 
  {  dialogRef.disableClose = true;}



  public getImage1() {
        return this.sanitizer.bypassSecurityTrustUrl("/assets/img/Picto_Global/auto1.png")
  }
  public getImage2() {
    return this.sanitizer.bypassSecurityTrustUrl("/assets/img/Picto_Global/auto2.png")
}
public getImage3() {
  return this.sanitizer.bypassSecurityTrustUrl("/assets/img/Picto_Global/auto3.png")
}


  
  onConfirm(): void {

    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
    window.location.reload()
  }

}